import { ISocialMediaListComponents } from '../../types/SocialSharing';
import { createRef, useState } from 'react';
import { useOnClickOutside } from '../../hooks/useOnClickOutside';
import { ShareIcon } from '@icons/ShareIcon';
import { SocialSharing } from '../SocialSharing';

interface SocialSharingIconType {
  id?: string;
  sharedItemName: string;
  sharedItemImage: string | undefined;
  socialMediaListComponents: ISocialMediaListComponents[];
}
export const SocialSharingIcon = ({
  id = 'social-sharing',
  sharedItemName,
  sharedItemImage,
  socialMediaListComponents,
}: SocialSharingIconType) => {
  const [showShare, setShowShare] = useState(false);
  const refContainer = createRef<HTMLDivElement>();
  useOnClickOutside(refContainer, () => setShowShare(false));

  return (
    <>
      <div id={id} className="w-min" ref={refContainer}>
        <div className="p-b-1.5 w-[200px] flex flex-row-reverse select-none">
          <div
            className="iconShare inline-block cursor-pointer"
            role="button"
            onClick={() => setShowShare(!showShare)}
            tabIndex={0}
            aria-label="Share"
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setShowShare(!showShare);
              }
            }}
          >
            <ShareIcon />
          </div>
        </div>
        {showShare && (
          <div className="inline-block">
            <SocialSharing
              isGeneric={false}
              socialMediaListComponents={socialMediaListComponents}
              sharedItemName={sharedItemName}
              sharedItemImage={sharedItemImage}
            />
          </div>
        )}
      </div>
    </>
  );
};
